/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgZaraz = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 1 3.5 L 6.5 3.5 L 6.5 2.5 L 1 2.5 Z M 1 3.5 "
}), /*#__PURE__*/React.createElement("path", {
  d: "M 1 5.5 L 6.5 5.5 L 6.5 4.5 L 1 4.5 Z M 1 5.5 "
}), /*#__PURE__*/React.createElement("path", {
  d: "M 10 9.5 L 6.5 9.5 L 6.5 8.5 L 10 8.5 Z M 10 9.5 "
}), /*#__PURE__*/React.createElement("path", {
  d: "M 6.5 7.5 L 10 7.5 L 10 6.5 L 6.5 6.5 Z M 6.5 7.5 "
}), /*#__PURE__*/React.createElement("path", {
  d: "M 15 13.5 L 6.5 13.5 L 6.5 12.5 L 15 12.5 Z M 15 13.5 "
}), /*#__PURE__*/React.createElement("path", {
  d: "M 6.5 11.5 L 15 11.5 L 15 10.5 L 6.5 10.5 Z M 6.5 11.5 "
}));

export default SvgZaraz;